import type { PropsWithChildren } from 'react';
import { useCallback, useMemo } from 'react';
import { MediaViewerConfigProvider } from '@frameio/shared/contexts';
import { useOpenInBrowserMutation } from '@frameio/shared/integrations/gql';
import { useSetCompositionPosition } from '../hooks';

export function AfterEffectsMediaViewerConfigProvider({
  children,
}: PropsWithChildren) {
  const { setCompositionPosition } = useSetCompositionPosition();
  const [openInBrowser] = useOpenInBrowserMutation({
    context: { resolveWithUXP: true },
  });

  const onDownloadUrl = useCallback(
    (url: string) => {
      openInBrowser({
        variables: { input: { url, omitLocaleParam: true } },
      });
    },
    [openInBrowser]
  );

  const value = useMemo(
    () => ({
      showFullScreenButton: false,
      showResolutionPicker: false,
      showTranscripts: true,
      showTranscriptionPanel: false,
      showContentCredentials: true,
      onDownloadUrl,
      onTimestampSelected: setCompositionPosition,
    }),
    [onDownloadUrl, setCompositionPosition]
  );

  return (
    <MediaViewerConfigProvider value={value}>
      {children}
    </MediaViewerConfigProvider>
  );
}
